<template>
  <section class="side-panel" role="complementary">
    <div class="side-panel-actions">
      <slot name="actions"></slot>
      <button @click="$emit('close')" class="side-panel-button" type="button">
        <font-awesome-icon icon="times-circle" />
      </button>
    </div>
    <div class="side-panel-slot">
      <slot></slot>
    </div>
  </section>
</template>

<script>
export default {
  name: "SidePanel",
};
</script>

<style lang="scss">
.side-panel {
  min-height: 0;
  width: 100%;
  flex: 1 1 0;
  display: flex;
  flex-direction: column;
  padding: 8px 12px 12px;
  overflow: hidden;
  background: rgba(0, 0, 0, 0.88);
  border: 2px solid rgba(255, 255, 255, 0.18);
  border-radius: 8px;
  box-shadow: 0 0 18px rgba(0, 0, 0, 0.65);
}

.side-panel-actions {
  flex: 0 0 auto;
  display: flex;
  justify-content: flex-end;
  gap: 14px;
  padding: 0 0 6px;
  background: linear-gradient(rgba(0, 0, 0, 0.96) 70%, rgba(0, 0, 0, 0));
}

.side-panel-button {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  padding: 0;
  border: 0;
  background: transparent;
  color: inherit;
  cursor: pointer;
  filter: drop-shadow(0 0 5px rgba(0, 0, 0, 1));

  svg {
    width: 100%;
    height: 100%;
  }

  &:hover {
    color: red;
  }
}

.side-panel-slot {
  min-height: 0;
  flex: 1 1 auto;
  overflow-x: hidden;
  overflow-y: auto;
  position: initial;
}
</style>
